import { query } from 'src/utils/request';
// 按预算项目_筛选项_预算部门
export async function getBudgetReportDepList(data) {
  return query('/zlb/budget/report/dep/list', {
    method: 'POST',
    data,
  });
}
// 预算项目报表列表
export async function queryBudgetReportProjectList(data) {
  return query('/zlb/budget/report/project/list', {
    method: 'POST',
    data,
  });
}
// 按预算科目_报表数据
export async function queryBudgetReportSubjectList(data) {
  return query('/zlb/budget/report/subject/list', {
    method: 'POST',
    data,
  });
}
// 按预算项目_筛选项_业务场景
export async function getBudgetReportFormTypeList(data) {
  return query('/zlb/budget/report/form-type/list', {
    method: 'POST',
    data,
  });
}
// 按预算项目_单独_报表数据
export async function queryBudgetReportProjectSingleList(data) {
  return query('/zlb/budget/report/project-single/list', {
    method: 'POST',
    data,
  });
}
// 预算科目（总) 报表数据
export async function queryBudgetReportSubjectTotalList(data) {
  return query('/zlb/budget/report/subject-total/list', {
    method: 'POST',
    data,
  });
}
